/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Xmlid6613IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Xmlid6613Icon(props: Xmlid6613IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 131 526"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M103.132 524.992 76.94 513.794c-5.756-2.461-8.737-8.833-6.978-14.841 2.51-8.569 5.64-21.886 6.76-37.793 2.532-35.943-5.925-68.057-25.135-95.447-48.71-69.456-28.517-122.98-10.7-170.203 6.243-16.547 12.7-33.658 16.597-51.78 9.266-43.075-33.49-82.655-52.807-98.02-5.012-3.986-6.164-11.124-2.635-16.467L17.7 5.538c3.968-6.007 12.203-7.352 17.882-2.925C61.813 23.06 125.13 81.118 109.265 154.87c-4.729 21.984-12.217 41.83-18.823 59.338-16.94 44.896-28.128 74.555 4.508 121.092 51.061 72.805 34.318 151.607 24.808 182.009-2.181 6.983-9.899 10.559-16.627 7.683z"
        }
      ></path>
    </svg>
  );
}

export default Xmlid6613Icon;
/* prettier-ignore-end */
